import { render, staticRenderFns } from "./SuccessView.vue?vue&type=template&id=b037a268&scoped=true"
import script from "./SuccessView.vue?vue&type=script&lang=js"
export * from "./SuccessView.vue?vue&type=script&lang=js"
import style0 from "./SuccessView.vue?vue&type=style&index=0&id=b037a268&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b037a268",
  null
  
)

export default component.exports